// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__nFgIo","spinner":"Loading_spinner__FBIHb","spin":"Loading_spin__4-DlN"};